import { useEffect, useState } from "react";
import UseWindowSize from "../UseWindowSize";
import Link from "next/link";
import { SliderRelatedPromo } from "../UserInterface/SliderRelatedPromo";

type PromoSliderProps = {
  promos: Array<any>;
  titledetailpromo: string;

};

const PromoSlider = ({ promos, titledetailpromo }: PromoSliderProps) => {
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);

  useEffect(() => {
    setWinSize(width);
  });

  if (promos.length < 1) {
    return <></>;
  } else {
    return (
      <div className="promo-slider-wrapper">
        {winSize !== null && (
          <div
            className={`${
              winSize > 600
                ? "promo-slider-container"
                : "promo-slider-container-mobile"
            }`}
          >
            <p>Promo & Penawaran Terkait</p>
            <SliderRelatedPromo>
              {promos.map((data, key) => {
                if (data.title != titledetailpromo) {
                  return (
                    <div key={key}>
                      <Link
                        href={"/promo-dan-penawaran/[slug]"}
                        as={`/promo-dan-penawaran/${data.slug}`}
                      >
                        <a>
                          <img
                            className="promo-slider-img"
                            src={
                              data.banner +
                              "?w=" +
                              winSize * (winSize > 600 ? 0.2 : 0.75)
                            }
                            alt={data.slug}
                          />
                        </a>
                      </Link>
                    </div>
                  );
                }
              })}
            </SliderRelatedPromo>
          </div>
        )}
        <style jsx>{`
          .promo-slider-wrapper {
            background-color: white;
            /*soft*/
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .promo-slider-wrapper .promo-slider-container {
            width: 100vw;
            max-width: 940px;
            padding-bottom: 32px;
          }
          .promo-slider-wrapper .promo-slider-container p {
            font-size: 24px;
            font-weight: bold;
            margin: 20px;
          }
          .promo-slider-wrapper .promo-slider-container div img {
            width: 100%;
            border-radius: 8px;
          }
          .promo-slider-wrapper .promo-slider-container div .promo-slider-img {
            max-height: 216px;
            width: calc(100vw / 2.5);
            height: 100%;
            margin: 0 8px;
          }
          .promo-slider-wrapper .promo-slider-container-mobile {
            display: none;
          }
          @media only screen and (min-width: 940px) {
            .promo-slider-wrapper
              .promo-slider-container
              div
              .promo-slider-img {
              max-height: 216px;
              width: calc(940px / 2.5);
              height: 100%;
              margin: 0 8px;
            }
          }
          @media only screen and (max-width: 600px) {
            .promo-slider-container {
              display: none;
            }
            .promo-slider-wrapper .promo-slider-container-mobile {
              display: flex;
              flex-direction: column;
              padding-bottom: 24px;
              width: 100%;
            }
            .promo-slider-wrapper .promo-slider-container-mobile p {
              font-size: 14px;
              font-weight: bold;
              margin: 16px;
            }
            .promo-slider-wrapper .promo-slider-container-mobile div {
              border-radius: 8px;
            }
            .promo-slider-wrapper .promo-slider-container-mobile div img {
              width: calc(100vw / 1.5);
              border-radius: 8px;
              margin: 0 8px;
            }
          }
        `}</style>
      </div>
    );
  }
};

export default PromoSlider;
